import React, { useCallback, ReactElement, useState } from "react";
import styled from "styled-components";
import { Modal } from "../Modal";

const ModalIframe = styled.iframe`
  flex: 1;
  width: 100%;
`;

export type IframeSliderModalOptions = {
  isOpen: boolean;
  title?: string;
  titleUrl?: string;
  iframeSrc?: string;
  iframeTitle?: string;
};

const DEFAULT_MODAL_OPTIONS = {
  isOpen: false,
};

type UseIframeSliderModalResult = {
  modalOptions: IframeSliderModalOptions;
  setModalOptions: (modalOptions: IframeSliderModalOptions) => void;
  openModalWithOptions: (modalOptions: Partial<IframeSliderModalOptions>) => void;
};

export const useIframeSliderModal = (initialModalOptions: IframeSliderModalOptions = DEFAULT_MODAL_OPTIONS): UseIframeSliderModalResult => {
  const [modalOptions, setModalOptions] = useState(initialModalOptions);
  const openModalWithOptions = useCallback(
    (opts) => {
      setModalOptions({
        isOpen: true,
        ...opts,
      });
    },
    [setModalOptions]
  );

  return {
    modalOptions,
    setModalOptions,
    openModalWithOptions,
  };
};

type IframeSliderModalProps = {
  id: string;
  modalOptions: IframeSliderModalOptions;
  setModalOptions: (modalOptions: IframeSliderModalOptions) => void;
};

export const IframeSliderModal = ({ id, modalOptions, setModalOptions }: IframeSliderModalProps): ReactElement => {
  const { isOpen, title, titleUrl, iframeSrc, iframeTitle } = modalOptions;

  const closeIframeSliderModal = useCallback(() => {
    setModalOptions(DEFAULT_MODAL_OPTIONS);
  }, [setModalOptions]);

  return (
    <Modal
      title={title}
      size="large"
      open={isOpen}
      onClose={closeIframeSliderModal}
      titleUrl={titleUrl || iframeSrc}
      mobileFullScreen
      rightAligned
      stickyHeader
      hideButtons
    >
      <ModalIframe id={id} title={iframeTitle || `${title} iframe`} src={iframeSrc} />
    </Modal>
  );
};
